import { motion } from "framer-motion";

const LOGOS = [
  { name: "Commonwealth Bank", img: "/lenders/cba.png" },
  { name: "ANZ", img: "/lenders/anz.png" },
  { name: "NAB", img: "/lenders/nab.png" },
  { name: "Macquarie", img: "/lenders/macquarie.png" },
  { name: "ING", img: "/lenders/ing.png" },
  { name: "Bankwest", img: "/lenders/bankwest.png" },
  { name: "Bendigo Bank", img: "/lenders/bendigo.png" },
  { name: "AMP", img: "/lenders/amp.png" },
  { name: "Pepper Money", img: "/lenders/pepper.png" },
  { name: "Liberty", img: "/lenders/liberty.png" },
  { name: "La Trobe Financial", img: "/lenders/latrobe.png" },
];

export default function LenderCollage() {
  return (
    <div className="h-full w-full grid grid-cols-3 grid-rows-4 gap-2.5 sm:gap-3 p-4 sm:p-5 bg-paper" data-testid="lender-collage">
      {LOGOS.map((l, i) => (
        <motion.div
          key={l.name}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: [0, -6, 0] }}
          transition={{
            opacity: { duration: 0.6, delay: 0.08 * i },
            y: { duration: 4.5 + (i % 4) * 0.7, repeat: Infinity, ease: "easeInOut", delay: i * 0.3 },
          }}
          className="rounded-2xl flex items-center justify-center px-3 py-2 bg-white border border-ink/5 shadow-sm"
          data-testid={`lender-tile-${i}`}
        >
          <img src={l.img} alt={`${l.name} — LMG panel lender`} className="max-h-8 sm:max-h-10 w-auto max-w-full object-contain" loading="lazy" />
        </motion.div>
      ))}
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: [0, -6, 0] }}
        transition={{
          opacity: { duration: 0.6, delay: 0.08 * LOGOS.length },
          y: { duration: 5.2, repeat: Infinity, ease: "easeInOut", delay: LOGOS.length * 0.3 },
        }}
        className="rounded-2xl flex items-center justify-center bg-gold border border-ink/5 shadow-sm"
        data-testid="lender-tile-more"
      >
        <span className="font-display font-bold text-xs sm:text-sm text-obsidian tracking-wide">+89 more</span>
      </motion.div>
    </div>
  );
}
